import { c as _c } from "react/compiler-runtime";
import React from "react";
import Svg from "../Svg";
const Icon = props => {
  const $ = _c(9);
  const {
    color,
    width,
    height
  } = props;
  const t0 = width || 25;
  const t1 = height || 25;
  const t2 = color || "#1D2939";
  let t3;
  let t4;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path d={"M203 200 c-5 -18 -14 -20 -104 -20 -55 0 -99 -3 -99 -7 0 -4 7 -33\n16 -65 16 -54 19 -58 48 -60 57 -3 111 4 118 15 3 6 12 39 18 75 10 49 17 66\n34 72 21 9 20 9 -2 9 -16 1 -26 -6 -29 -19z m-13 -57 c-4 -16 -11 -40 -14 -55\n-6 -27 -9 -28 -70 -28 l-63 0 -12 41 c-7 23 -15 47 -18 55 -4 11 13 14 90 14\nl96 0 -9 -27z"} />;
    t4 = <path d="M62 19 c5 -14 21 -14 26 0 2 6 -4 11 -13 11 -9 0 -15 -5 -13 -11z" />;
    t5 = <path d="M122 19 c5 -14 21 -14 26 0 2 6 -4 11 -13 11 -9 0 -15 -5 -13 -11z" />;
    $[0] = t3;
    $[1] = t4;
    $[2] = t5;
  } else {
    t3 = $[0];
    t4 = $[1];
    t5 = $[2];
  }
  let t6;
  if ($[3] !== t2) {
    t6 = <g transform="translate(0.000000,25.000000) scale(0.100000,-0.100000)" fill={t2} stroke="none">{t3}{t4}{t5}</g>;
    $[3] = t2;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== t0 || $[6] !== t1 || $[7] !== t6) {
    t7 = <Svg width={t0} height={t1} viewBox="0 0 25 25" stroke="none">{t6}</Svg>;
    $[5] = t0;
    $[6] = t1;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
};
export default Icon;